import { render, staticRenderFns } from "./PersonnelRecordChronicleTypeChip.vue?vue&type=template&id=14811f19"
import script from "./PersonnelRecordChronicleTypeChip.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordChronicleTypeChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports